<template>
  <transition name="slide-in-right">
    <div
      v-if="isMinimized && webinar"
      class="webinar-minimized"
    >
      <!-- Swatch thumbnail — uses <img> so it's immune to player.js -->
      <div class="webinar-minimized__preview">
        <img
          v-if="swatchUrl"
          :src="swatchUrl"
          alt=""
          class="webinar-minimized__swatch"
        >
        <div
          v-else
          class="webinar-minimized__placeholder d-flex align-center justify-center fill-height"
        >
          <v-icon
            color="white"
            large
          >
            mdi-video-outline
          </v-icon>
        </div>
      </div>

      <!-- Overlay with status and CTA -->
      <div class="webinar-minimized__overlay d-flex flex-column align-center justify-center pa-2">
        <v-chip
          color="red"
          text-color="white"
          x-small
          class="mb-1"
        >
          <v-icon
            left
            x-small
          >
            mdi-circle
          </v-icon>
          Event in Progress
        </v-chip>
        <v-btn
          color="primary"
          rounded
          x-small
          class="mt-1"
          @click="returnToModal"
        >
          Click to Return
        </v-btn>
      </div>

      <!-- Title bar -->
      <div class="webinar-minimized__title-bar d-flex align-center px-2 py-1">
        <span class="text-caption white--text text-truncate flex-grow-1">
          {{ webinar.title }}
        </span>
        <v-btn
          icon
          x-small
          dark
          data-qa="webinar-minimized-close"
          @click="handleClose"
        >
          <v-icon x-small>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { extractWistiaSwatchUrl } from '@/api/videos';

export default {
  name: 'WebinarMinimized',

  computed: {
    ...mapGetters('videos', ['isMinimized', 'minimizedWebinar']),
    webinar() { return this.minimizedWebinar; },

    swatchUrl() {
      return extractWistiaSwatchUrl(this.webinar?.wistia_url);
    },
  },

  methods: {
    ...mapActions('videos', ['openModal', 'clearMinimized']),

    returnToModal() {
      if (this.webinar) this.openModal(this.webinar.id);
    },

    handleClose() {
      this.clearMinimized();
    },
  },
};
</script>

<style lang="scss" scoped>
.webinar-minimized {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 280px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 9000;
  background: #000;
  display: flex;
  flex-direction: column;

  &__preview {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    background: #1a1a2e;
  }

  &__swatch {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(5px);
  }

  &__placeholder {
    width: 100%;
    height: 100%;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    // Cover preview area only, leave title bar clear
    height: calc(100% - 36px);
    background: rgba(0, 0, 0, 0.55);
  }

  &__title-bar {
    background: rgba(0, 0, 0, 0.75);
    min-height: 36px;
  }
}

.slide-in-right-enter-active,
.slide-in-right-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-in-right-enter,
.slide-in-right-leave-to {
  transform: translateX(120%);
  opacity: 0;
}
</style>
